<!-- Feature Carousel -->
<div id="featureCarousel" class="carousel slide carousel-fade features_carousel" data-bs-ride="carousel"
    data-bs-interval="1000">
    <!-- Indicators/dots -->
    <div class="carousel-indicators menu">
        <button type="button" data-bs-target="#featureCarousel" data-bs-slide-to="0" class="active btn"
            aria-label="gallery icon">
            <img class="default_icon" src="/assets/images/gallery-icon.svg" alt="Gallery icon ">
            <img class="active_icon" src="/assets/images/gallery-icon-red.svg" alt="Gallery icon">
        </button>
        <button type="button" data-bs-target="#featureCarousel" data-bs-slide-to="1" class="btn" aria-label="gps icon">
            <img class="default_icon" src="/assets/images/hp-gps.svg" alt="Gps icon">
            <img class="active_icon" src="/assets/images/hp-gps-red.svg" alt="Gps icon">
        </button>
        <button type="button" role="button" data-bs-target="#featureCarousel" data-bs-slide-to="2" class="btn"
            aria-labelledby="file icon">
            <img class="default_icon" src="/assets/images/hp-folder.svg" alt="Folder icon">
            <img class="active_icon" src="/assets/images/hp-folder-red.svg" alt="Folder icon">
        </button>
        <button type="button" data-bs-target="#featureCarousel" data-bs-slide-to="3" class="btn"
            aria-label="vault icon">
            <img class="default_icon" src="/assets/images/hp-safebox.svg" alt="Vault icon">
            <img class="active_icon" src="/assets/images/hp-safebox-red.svg" alt="Vault icon">
        </button>
        <button type="button" data-bs-target="#featureCarousel" data-bs-slide-to="4" class="btn"
            aria-label="video icon">
            <img class="default_icon" src="/assets/images/hp-playbtn-new.svg" alt="Video icon">
            <img class="active_icon" src="/assets/images/hp-playbtn-red.svg" alt="Video icon">
        </button>
        <button type="button" data-bs-target="#featureCarousel" data-bs-slide-to="5" class="btn"
            aria-label="family icon">
            <img class="default_icon" src="/assets/images/hp-fam.svg" alt="Family icon">
            <img class="active_icon" src="/assets/images/hp-fam-red.svg" alt="Family icon">
        </button>
        <button type="button" data-bs-target="#featureCarousel" data-bs-slide-to="6" class="btn"
            aria-label="calendar icon">
            <img class="default_icon" src="/assets/images/hp-cal.svg" alt="Calendar icon">
            <img class="active_icon" src="/assets/images/hp-cal-red.svg" alt="Calendar icon">
        </button>
        <button type="button" data-bs-target="#featureCarousel" data-bs-slide-to="7" class="btn"
            aria-label="emergency contact icon">
            <img class="default_icon" src="/assets/images/hp-contct.svg" alt="Emergency contact icon">
            <img class="active_icon" src="/assets/images/hp-contct-red.svg" alt="Emergency contact icon">
        </button>
    </div>

    <!-- The slideshow/carousel -->
    <div class="carousel-inner">
        <div class="carousel-item active">
            <div class="single_featuree">
                <div class="feature_app_screen">
                    <img src="/assets/images/carousel-circle-image1.webp" alt="Photo in phone image">
                </div>
            </div>
        </div>
        <div class="carousel-item">
            <div class="single_featuree">
                <div class="feature_app_screen">
                    <img src="/assets/images/carousel-circle-image1.webp" alt="GPS in phone image">
                </div>
            </div>
        </div>
        <div class="carousel-item">
            <div class="single_featuree">
                <div class="feature_app_screen">
                    <img src="/assets/images/carousel-circle-image1.webp" alt="Files in phone image">
                </div>
            </div>
        </div>
        <div class="carousel-item">
            <div class="single_featuree">
                <div class="feature_app_screen">
                    <img src="/assets/images/carousel-circle-image1.webp" alt="Personal vault in phone image">
                </div>
            </div>
        </div>
        <div class="carousel-item">
            <div class="single_featuree">
                <div class="feature_app_screen">
                    <img src="/assets/images/carousel-circle-image1.webp" alt="Legacy video folder in phone image">
                </div>
            </div>
        </div>
        <div class="carousel-item">
            <div class="single_featuree">
                <div class="feature_app_screen">
                    <img src="/assets/images/carousel-circle-image1.webp" alt="Family folder in phone image">
                </div>
            </div>
        </div>
        <div class="carousel-item">
            <div class="single_featuree">
                <div class="feature_app_screen">
                    <img src="/assets/images/carousel-circle-image1.webp" alt="Calendar in phone image">
                </div>
            </div>
        </div>
        <div class="carousel-item">
            <div class="single_featuree">
                <div class="feature_app_screen">
                    <img src="/assets/images/carousel-circle-image1.webp" alt="Emergency folder in phone image">
                </div>
            </div>
        </div>
    </div>
</div>